import React, { useCallback, useEffect, useState } from 'react'
import Flex, { FlexItem } from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { Divider } from '@material-ui/core'
import { formValues } from 'redux-form'
import { useSelector } from 'react-redux'
import { isFriday, isSaturday } from 'date-fns'
import { is } from '../../../../components/MediaQuery'
import { PriceInput } from '../../../../components/FormBuilder'
import { Label } from '../PriceStyle'
import { IStore } from '../../../../reducers'
import { getSelectedLanguage } from '../../../../reducers/userAccount/selectors/userLanguage'

export const isWeekend = date => isFriday(date) || isSaturday(date)

const PricesTypes = formValues<any>({ kids: 'kids', kidsPrice: 'kidsPrice' })(
  function({
             kids,
             kidsPrice,
             size,
             pricePerPerson,
             asArray = false,
             roomSize = 0,
             extraBed = undefined,
             isHint = false,
             readonly = false,
             date = new Date(),
           }) {
    const roomWithAdditional = useSelector((state: IStore) =>
      state.bookingCalendar.rooms.filter(
        room => room.additionalBeds && room.additionalBeds !== '0',
      ),
    )
    const isSidebarOpen = useSelector(
      (state: IStore) => state.bookingCalendar.isSidebarOpen,
    )

    const [wrap, setWrap] = useState(
      isSidebarOpen &&
      roomWithAdditional.length !== 0 &&
      window.innerWidth < 1200,
    )

    function calcWrap() {
      setWrap(
        roomWithAdditional.length !== 0 &&
        isSidebarOpen &&
        window.innerWidth < 1200,
      )
    }

    useEffect(() => {
      calcWrap()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSidebarOpen])

    useEffect(() => {
      window.addEventListener('resize', calcWrap, true)
      return () => {
        window.removeEventListener('resize', calcWrap, true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSidebarOpen])

    const { t } = useTranslation()
    const isDesktop = is.desktop() && !wrap

    const PriceAdults = () => {
      const arr = []

      for (let i = 1; i <= roomSize; i++) {
        arr.push(
          <PriceRow
            readonly={readonly}
            isHint={isHint}
            date={date}
            size={size}
            priceType={`adult.${i - 1}`}
            label={`${t('BBO_1466_adult_person')} (x${i})`}
          />,
        )
      }

      return arr.reverse()
    }

    return (
      <>
        <div style={{ margin: `${15 * size}px 0px` }}>
          {isDesktop && (
            <DesktopHeader
              readonly={readonly}
              date={date}
              size={size}
              isHint={isHint}
            />
          )}
          {pricePerPerson ? (
            <>
              {asArray ? (
                <>{PriceAdults()}</>
              ) : (
                <>
                  <PriceRow
                    readonly={readonly}
                    size={size}
                    isHint={isHint}
                    date={date}
                    priceType={'adult2'}
                    label={`${t('BBO_1466_adult_person')} (x2)`}
                    wrap={wrap}
                  />{' '}
                  {!isDesktop && (
                    <Divider
                      style={{
                        margin: `${20 * size}px 0px ${10 * size}px 0px`,
                        width: '100%',
                      }}
                    />
                  )}
                  <PriceRow
                    readonly={readonly}
                    size={size}
                    isHint={isHint}
                    date={date}
                    priceType={'adult1'}
                    label={`${t('BBO_1466_adult_person')} (x1)`}
                    wrap={wrap}
                  />
                  {!isDesktop && (
                    <Divider
                      style={{
                        margin: `${20 * size}px 0px ${10 * size}px 0px`,
                        width: '100%',
                      }}
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <PriceRow
                readonly={readonly}
                size={size}
                isHint={isHint}
                date={date}
                priceType={'price'}
                label={`${t('reservation_price')}`}
                wrap={wrap}
              />
              {!isDesktop && (
                <Divider
                  style={{
                    margin: `${20 * size}px 0px ${10 * size}px 0px`,
                    width: '100%',
                  }}
                />
              )}
            </>
          )}

          {kidsPrice &&
          kids &&
          kids.map((kid, index) =>
            kid.ageFrom !== undefined && kid.ageTo !== undefined ? (
              <>
                <PriceRow
                  readonly={readonly}
                  size={size}
                  isHint={isHint}
                  date={date}
                  priceType={`kid[${index}]`}
                  wrap={wrap}
                  label={`${t('BBO_963_child')} (${kid.ageFrom}-${
                    kid.ageTo
                  })`}
                />
                {!isDesktop && (
                  <Divider
                    style={{
                      margin: `${20 * size}px 0px ${10 * size}px 0px`,
                      width: '100%',
                    }}
                  />
                )}
              </>
            ) : (
              <></>
            ),
          )}

          {((extraBed === undefined && roomWithAdditional.length !== 0) ||
            extraBed) && (
            <>
              <PriceRow
                readonly={readonly}
                wrap={wrap}
                size={size}
                isHint={isHint}
                date={date}
                priceType={'additional'}
                label={`${t('room_reservation_additional_bed')}`}
              />
              {!isDesktop && !wrap && (
                <Divider
                  style={{
                    margin: `${20 * size}px 0px ${10 * size}px 0px`,
                    width: '100%',
                  }}
                />
              )}
            </>
          )}
        </div>
      </>
    )
  },
)

const DesktopHeader = formValues<any>({
  from: 'stayLongFrom',
  stay: 'stay',
  to: 'stayShortTo',
  weekend: 'weekendPrice',
})(function({ readonly = false, size, isHint, date, stay, to, from, weekend }) {
  const { t } = useTranslation()

  const lang = useSelector(getSelectedLanguage)

  const Item = ({ children }) => (
    <FlexItem
      grow={1}
      shrink={1}
      basis={'1%' as any}
      style={{
        marginRight: `${5 * size}px`,
        minWidth: 0,
        overflowWrap: 'break-word',
      }}
    >
      {children}
    </FlexItem>
  )

  const SuperLabel = ({ children }) => (
    <Label
      as={'p'}
      style={{
        fontSize: `${
          isHint ? (lang === 'ru' ? 11 * size : 14 * size) : 12 * size
        }px`,
        fontWeight: 400,
        margin: 0,
        textAlign: 'center',
        width: '100%',
      }}
    >
      {children}
    </Label>
  )

  return (
    <Flex row={true} style={{ marginBottom: `${12 * size}px` }}>
      <div style={{ maxWidth: '30%', minWidth: '30%' }}/>
      <Flex
        row={true}
        style={{ marginRight: `${5 * size}px`, minWidth: '70%' }}
      >
        {(readonly || (!weekend || (weekend && !isWeekend(date)))) && (
          <Item>
            <SuperLabel>
              {t('BBO_1466_standard')}
              {((stay && !!Number(to)) || !!Number(from)) &&
              (Number(to + 1) < Number(from) ||
                (stay && !!Number(to) && !Number(from))) ? (
                <div>
                  {!!Number(to)
                    ? `(${t('BKO_1130_from')} ${Number(to + 1)}${
                      !!Number(from)
                        ? ` ${t('BKO_1130_to')} ${Number(from - 1)})`
                        : ')'
                    }`
                    : !!Number(from)
                      ? `(${t('BKO_1130_to')} ${Number(from - 1)})`
                      : ''}
                </div>
              ) : (
                ``
              )}
            </SuperLabel>
          </Item>
        )}
        {((readonly && weekend) || (weekend && isWeekend(date))) && (
          <Item>
            {' '}
            <SuperLabel>{`${t('BBO_1466_standard')} ${t(
              'BBO_1466_weekend',
            )}`}</SuperLabel>
          </Item>
        )}
        {stay && !!Number(to) && (
          <Item>
            <SuperLabel>
              {t('BBO_1466_short_stay')}
              <div>({`${t('BKO_1130_to')} ${Number(to)}`})</div>
            </SuperLabel>
          </Item>
        )}
        {stay && !!Number(from) && (
          <Item>
            <SuperLabel>
              {t('BBO_1466_long_stay')}
              <div>({`${t('BKO_1130_from')} ${Number(from)}`})</div>
            </SuperLabel>
          </Item>
        )}
      </Flex>
    </Flex>
  )
})

const PriceRow = formValues<any>({
  from: 'stayLongFrom',
  stay: 'stay',
  to: 'stayShortTo',
  weekend: 'weekendPrice',
})(function({
              size,
              isHint,
              date,
              priceType,
              label,
              stay,
              to,
              from,
              weekend,
              wrap = false,
              readonly = false,
            }) {
  const isDesktop = is.desktop() && !wrap
  const { t } = useTranslation()

  const Input = useCallback(
    ({ type }) => (
      <PriceInput.ReduxField
        disableFocus={true}
        readonly={true}
        wrapperStyle={{
          marginRight: `${5 * size}px`,
          width: isDesktop ? '100%' : '45%',
        }}
        width={'100%'}
        size={size}
        name={`${priceType}.${type}`}
        label={
          !isDesktop ? (
            <>
              {' '}
              {t(
                `${
                  type === 'weekend'
                    ? `${t('BBO_1466_standard')} ${t('BBO_1466_weekend')}`
                    : t(`BBO_1466_${type}`)
                }`,
              )}
              {type === 'standard' ? (
                ((stay && !!Number(to)) || !!Number(from)) &&
                (Number(to + 1) < Number(from) ||
                  (stay && !!Number(to) && !Number(from))) ? (
                  <div>{`${
                    !!Number(to)
                      ? `(${t('BKO_1130_from')} ${Number(to + 1)}${
                        !!Number(from)
                          ? ` ${t('BKO_1130_to')} ${Number(from - 1)})`
                          : ')'
                      }`
                      : !!Number(from)
                      ? `(${t('BKO_1130_to')} ${Number(from - 1)})`
                      : ''
                  }`}</div>
                ) : (
                  ''
                )
              ) : type === 'short_stay' ? (
                <div>{`(${t('BKO_1130_to')} ${Number(to)})`}</div>
              ) : type === 'long_stay' ? (
                <div>{`(${t('BKO_1130_from')} ${Number(from)})`}</div>
              ) : (
                ''
              )}
            </>
          ) : (
            ''
          )
        }
        allowNullValue={true}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [size, isDesktop, priceType, from, to],
  )

  return (
    <Flex
      row={isDesktop}
      column={!isDesktop}
      style={{ marginBottom: `${9 * size}px`, width: '100%' }}
      alignCenter={true}
    >
      <Label
        style={{
          fontSize: `${isDesktop ? `${14 * size}px` : `${size}rem`}`,
          fontWeight: 400,
          maxWidth: isDesktop ? '30%' : '100%',
          minWidth: isDesktop ? '30%' : '100%',
        }}
      >
        {label}
      </Label>
      <Flex
        style={
          !isDesktop ||
          (!weekend &&
            stay &&
            (!!Number(to) ? !Number(from) : !!Number(from))) ||
          !(stay && (!!Number(to) || !!Number(from)))
            ? { width: '100%' }
            : {}
        }
        justifyBetween={!isDesktop}
      >
        {(readonly || (!weekend || (weekend && !isWeekend(date)))) && (
          <Input type={`standard`}/>
        )}
        {((readonly && weekend) || (weekend && isWeekend(date))) && (
          <Input type={`weekend`}/>
        )}
      </Flex>
      {stay && (!!Number(to) || !!Number(from)) && (
        <Flex
          style={
            !isDesktop ||
            (!weekend &&
              stay &&
              (!!Number(to) ? !Number(from) : !!Number(from)))
              ? { width: '100%' }
              : {}
          }
          justifyBetween={!isDesktop}
        >
          {stay && !!Number(to) && <Input type={`short_stay`}/>}
          {stay && !!Number(from) && <Input type={`long_stay`}/>}
        </Flex>
      )}
    </Flex>
  )
})

export default formValues<any>({
  pricePerPerson: 'pricePerPerson',
})(PricesTypes)
